import { configureStore } from '@reduxjs/toolkit';
import profileReducer from '../slices/profileSlice';
import proficiencyReducer from '../slices/proficiencySlice';

const store = configureStore({
  reducer: {
    profile: profileReducer,
    proficiency: proficiencyReducer,
  },
});

export default store;
